import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Timer from 'components/Timer';
import Overlay from 'componentsV2/Hero/components/Overlay';
import HeroBackground from 'componentsV2/Hero/components/HeroBackground';
import ActionButtons from 'componentsV2/ActionButtons';
import HeadLine from 'componentsV2/Headline';
import Description from 'componentsV2/Description';
import Logo from 'componentsV2/Logo';
import { setRecommendationIdAction } from 'index/AppActions';

import { EventProcessor } from '../../processors';
import style from './EventView.module.scss';

const Event = ({
  analytics,
  callCollectionImpressionEvent,
  deactivateTimer,
  item,
  isOffset,
  setRecommendationId,
}) => {
  const {
    backgroundProps,
    buttonArray,
    description,
    countdownTime,
    logoProps,
    title,
  } = EventProcessor({
    panel: item,
    analytics,
    callCollectionImpressionEvent,
    additionalFunctions: { setRecommendationId },
  });

  return (
    <HeroBackground theme={style} {...backgroundProps}>
      <Overlay theme={style} isOffset={isOffset}>
        <Logo theme={style} {...logoProps} unoptimized />
        <HeadLine theme={style} text={title} />
        <Timer countdownTime={countdownTime} setIsActive={deactivateTimer} />
        <Description theme={style} description={description} />
        <ActionButtons buttons={buttonArray} theme={style} isReversed />
      </Overlay>
    </HeroBackground>
  );
};

Event.propTypes = {
  analytics: PropTypes.shape({}),
  callCollectionImpressionEvent: PropTypes.func,
  deactivateTimer: PropTypes.func.isRequired,
  isOffset: PropTypes.bool,
  item: PropTypes.shape({}),
  setRecommendationId: PropTypes.func.isRequired,
};

export default connect(() => ({}), {
  setRecommendationId: setRecommendationIdAction,
})(Event);
